import Trip from './Trip/Trip';
import TripsList from './TripsList/TripsList';
import PriceBox from './PriceBox/PriceBox';
import getTagStylesFromTag from './utils/getTagStylesFromTag';

export { Trip, TripsList, PriceBox, getTagStylesFromTag };

//Ключи для JSON прогулки
export const ID_KEY = 'id';
export const CONTENT = 'content';
export const PARENT_KEY = 'parent';
export const ALIAS_KEY = 'alias';
export const URI_KEY = 'uri';
export const PAGE_TITLE = 'pagetitle';
export const FILTERS_KEY = 'tv.filters';
export const TIMES_OF_DAY_KEY = 'tv.timesOfDay';
export const PREVIEW_TAGS_KEY = 'tv.e_preview_tags';
export const DURATION_KEY = 'tv.e_duration';
export const PREVIEW_ALT_DURATION_KEY = 'tv.e_preview_alt_duration';
export const POINTS_KEY = 'tv.e_points';
export const HIDE_NEXT_CRUISE_KEY = 'tv.e_hide_next-cruise';
export const PRICE_KEY = 'tv.e_price';
export const CURRENCY_SIGN_KEY = 'currency_sign';
export const PRICE_ON_PEER_KEY = 'tv.e_price_on_pier';
export const PRICE_SUBTITLE = 'tv.e_price_subtitle';
export const E_SHOW_NEXT_CRUISE = 'tv.e_hide_next-cruise';
export const E_START_DATE_KEY = 'tv.e_start_date';
export const E_END_DATE_KEY = 'tv.e_end_date';
export const E_EXCLUDED_DAYS_KEY = 'tv.e_excluded_days';
export const E_DATE_DISABLED_KEY = 'tv.e_dateDisabled';
export const E_START_TIME_KEY = 'tv.e_start_time';
export const E_START_POINTS_KEY = 'tv.e_start_points';
export const E_SCHEDULE_TIME_KEY = 'tv.e_schedule_time';
export const E_DATETIME_OFFSET_KEY = 'tv.e_datetime_offset';
export const E_SELECT_API_KEY = 'tv.e_select_api';
export const E_START_SCHEDULE_TIME = 'tv.e_start_schedule_time';
export const ID_ASTRA_KEY = 'tv.id_astra';
export const ID_TRANS_SERVICE_KEY = 'tv.e_trans_service_id';
export const ID_NEVATRAVEL_KEY = 'tv.program_id';
export const ID_NEVATRAVEL_PIER = 'tv.pier_departure_id';
export const IS_NEVATRAVEL_NIGHT = 'tv.nevatravel_is_night';
export const ASTRA_MODAL_CATEGORY = 'tv.buy_through_modal';
export const ID_TEPLOHODINFO_KEY = 'tv.teplohod_info_key';
export const PREVIEW_IMAGE_URI = 'tv.e_preview_img_sm';
export const E_PRICE = 'tv.e_price';
export const E_POPULARITY = 'tv.popularity';
